var AlligatorView, Backbone, SharedAjaxErrorView, SharedSpinnerView, StepTwoBaseView, SupportCategoryDropdownTemplate, SupportErrorHelper, SupportLegacyOrderBanner, SupportProgressBarView, SupportStepActionsView, SupportStepTwoActionsTemplate, SupportSubCategoryDropdownTemplate, SupportUtilsHelper,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportProgressBarView = require('../progress_bar_view');

SupportLegacyOrderBanner = require('../legacy_order_banner_view');

SupportStepActionsView = require('../step_actions_view');

SharedAjaxErrorView = require('../../../../shared/frontend/views/ajax_error_view');

SupportErrorHelper = require('../../helpers/error');

SharedSpinnerView = require('../../../../shared/frontend/views/spinner_view');

SupportUtilsHelper = require('../../helpers/utils');

AlligatorView = require('../../../../shared/frontend/views/alligator_view');

Backbone = require('backbone');

Backbone.$ = $;

SupportStepTwoActionsTemplate = require('../../../step_two_actions.html.mustache');

SupportCategoryDropdownTemplate = require('../../../category_dropdown.html.mustache');

SupportSubCategoryDropdownTemplate = require('../../../sub_category_dropdown.html.mustache');

StepTwoBaseView = (function(superClass) {
  extend(StepTwoBaseView, superClass);

  function StepTwoBaseView() {
    this.subCategoryChangeCallback = bind(this.subCategoryChangeCallback, this);
    return StepTwoBaseView.__super__.constructor.apply(this, arguments);
  }

  StepTwoBaseView.prototype.className = 'step-two';

  StepTwoBaseView.prototype.events = {
    'general-message .inbenta-content': 'enableTicketDirectionButton',
    'help-text .inbenta-content': 'enableResolvedButton',
    'no-answer .inbenta-content': 'enableTicketDirectionButton',
    'change .category': 'setCategoryToWindow',
    'change .sub-category': 'subCategoryChangeCallback',
    'click .view_fine_print': 'renderFinePrint',
    'click #continueToTicket': 'disableAllButton',
    "click #orderNotListed": "disableAllButton",
    'click #merchant_link': 'renderPickOrder'
  };

  StepTwoBaseView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    if (Groupon.Support.MAXINDEX === 2) {
      this.id = 1;
    } else {
      this.id = 2;
    }
    this.categoryTemplate = SupportCategoryDropdownTemplate;
    this.subCategoryTemplate = SupportSubCategoryDropdownTemplate;
    this.tagLine = Groupon.Support.Tagline;
    this.dropDownModel = this.options.dropDownModel;
    this.errorView = new SharedAjaxErrorView();
    this.spinnerView = new SharedSpinnerView();
    return this.flexibleContactChannelModel = Groupon.Support.FlexibleContactChannelModel;
  };

  StepTwoBaseView.prototype.hideComponents = function() {
    window.hideFooterLinks();
    if ($("#intl_footer").length > 0) {
      $("#intl_footer").hide();
    }
    SupportUtilsHelper.hideFloatingBoldChat();
    return AlligatorView.hideWidgets();
  };

  StepTwoBaseView.prototype.renderProgressBar = function(contentWrapper) {
    var progressBar;
    progressBar = new SupportProgressBarView;
    progressBar.render();
    return contentWrapper.append(progressBar.el);
  };

  StepTwoBaseView.prototype.renderLegacyOrderBanner = function(contentWrapper) {
    var legacyOrderBanner;
    legacyOrderBanner = new SupportLegacyOrderBanner;
    legacyOrderBanner.render();
    return contentWrapper.append(legacyOrderBanner.el);
  };

  StepTwoBaseView.prototype.renderOrderInfo = function(contentWrapper) {
    var merchant, order;
    if (Groupon.Support.currentOrder && Groupon.Support.currentOrder !== null) {
      order = Groupon.Support.currentOrder;
      merchant = getDealMerchantName();
      return contentWrapper.append("<h6 class='cb'><span id='tellUs'>" + (I18n.t('js.modules.support.tellusaboutorder')) + "</span> <span id='merchant_link' data-bhw='merchant_link'><a class='deal-title'>" + merchant + "</a>.</span></h6>");
    } else {
      return contentWrapper.append("<h6 class='cb'><span id='tellUs'>" + (I18n.t('js.modules.support.tellusaboutproblem')) + "</span></h6>");
    }
  };

  StepTwoBaseView.prototype.renderLiveChat = function(childViewElem) {
    var liveChatmode;
    liveChatmode = Groupon.Support.LiveChatModel.getDefaultStepTwoLiveChatMode();
    if (Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat()) {
      Groupon.Support.LiveChatView.setLiveChat(liveChatmode, Groupon.Support.LiveChatModel.getDefaultLiveChatType());
      Groupon.Support.LiveChatView.renderView(childViewElem, {});
      return SupportUtilsHelper.showFloatingBoldChat();
    }
  };

  StepTwoBaseView.prototype.handleAjaxErrors = function() {
    return this.errorView.render({
      container: this.$el
    });
  };

  StepTwoBaseView.prototype.filterDropdowns = function(dropdowns, allTags) {
    return _.filter(dropdowns, (function(_this) {
      return function(item) {
        if (item.tagLines == null) {
          return true;
        }
        return _.some(item.tagLines, function(tl) {
          var commonTags, filterTags;
          filterTags = tl.split(";");
          commonTags = _.intersection(allTags, filterTags);
          return commonTags.length === filterTags.length;
        });
      };
    })(this));
  };

  StepTwoBaseView.prototype.getCategoryList = function() {
    var allTags, dropdowns;
    dropdowns = this.getDropdowns();
    if (window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.filterDropdowns : void 0) && (this.tagLine != null)) {
      allTags = this.tagLine.split(",");
      dropdowns = this.filterDropdowns(dropdowns, allTags);
    }
    return _.sortBy(dropdowns, function(category) {
      return parseInt(category.weight);
    });
  };

  StepTwoBaseView.prototype.getSubCategoryList = function() {
    var allTags, category, dropdowns, subCategories;
    dropdowns = this.getDropdowns();
    category = _.find(dropdowns, function(item) {
      return item.id === Groupon.Support.ContentModel.getCategory().id;
    });
    subCategories = category.subCategories;
    if (window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.filterDropdowns : void 0) && (this.tagLine != null)) {
      allTags = this.tagLine.split(",");
      subCategories = this.filterDropdowns(subCategories, allTags);
    }
    return _.sortBy(subCategories, function(s) {
      return parseInt(s.weight);
    });
  };

  StepTwoBaseView.prototype.getDropdowns = function() {
    return this.dropDownModel.attributes;
  };

  StepTwoBaseView.prototype.renderStepTwoActions = function() {
    var stepActions;
    stepActions = new SupportStepActionsView({
      template: SupportStepTwoActionsTemplate
    });
    stepActions.render();
    this.$el.append(stepActions.el);
    if (Groupon.Support.MAXINDEX === 2) {
      return this.$('.back').hide();
    }
  };

  StepTwoBaseView.prototype.hideContactUsButton = function() {
    return this.$('.contact-us').hide();
  };

  StepTwoBaseView.prototype.disableAllButton = function() {
    this.$('.issue-check').hide();
    this.$('.direct-ticket').hide();
    return this.$('.refund-my-request').hide();
  };

  StepTwoBaseView.prototype.sendTrackyCallForHelpContentBeingShown = function(isHelpContentProper) {
    var data;
    data = {
      categoryId: this.getSubCategoryId(),
      subCategoryId: this.getSubCategoryId(),
      tagline: Groupon.Support.Tagline,
      country: window.country.name,
      contentId: Groupon.Support.ContentModel.getContentId()
    };
    if (isHelpContentProper) {
      return TrackingHub.add("help-content-shown", {
        helpContentShown: data
      });
    } else {
      return TrackingHub.add("help-content-not-shown", {
        helpContentNotShown: data
      });
    }
  };

  StepTwoBaseView.prototype.helpContentLoadError = function() {
    var category_id, sub_category_id;
    this.spinnerView.hide();
    category_id = this.getCategoryId();
    sub_category_id = this.getSubCategoryId();
    this.$('.inbenta-content').attr("data-bhw", "hw__" + country.name + "__" + category_id + "__" + sub_category_id + "__no-content-shown");
    return this.$('.inbenta-content').html(I18n.t("js.modules.support.default_help_text"));
  };

  StepTwoBaseView.prototype.getCategoryId = function() {
    var category_id, contentCategory;
    contentCategory = Groupon.Support.ContentModel.getCategory();
    return category_id = (contentCategory != null ? contentCategory.id : void 0) != null ? contentCategory.id : null;
  };

  StepTwoBaseView.prototype.getSubCategoryId = function() {
    var contentSubCategory, sub_category_id;
    contentSubCategory = Groupon.Support.ContentModel.getSubCategory();
    return sub_category_id = (contentSubCategory != null ? contentSubCategory.id : void 0) != null ? contentSubCategory.id : null;
  };

  StepTwoBaseView.prototype.subCategoryChangeCallback = function() {
    this.setSubCategoryToWindow();
    return this.setFlexibleContactChannels();
  };

  StepTwoBaseView.prototype.clearElement = function(elem) {
    return this.$(elem).empty();
  };

  StepTwoBaseView.prototype.close = function() {};

  StepTwoBaseView.prototype.renderFinePrint = function() {
    return SupportUtilsHelper.renderFinePrint();
  };

  StepTwoBaseView.prototype.renderPickOrder = function() {
    window.selectOrderFromMygroupons = false;
    return propagateEventBeforeReplacingElements(function() {
      return Backbone.history.navigate('#pick-order', {
        trigger: true
      });
    });
  };

  StepTwoBaseView.prototype.shouldFetchFlexibleContactChannels = function() {
    return this.isFlexibleContactChannelsEnabled() && !this.flexibleContactChannelModel.hasContactChannels();
  };

  StepTwoBaseView.prototype.isFlexibleContactChannelsEnabled = function() {
    return window.evaluate(window.experiments.showFlexibleContactChannels);
  };

  StepTwoBaseView.prototype.areIdsSame = function(id1, id2) {
    if ((id1 != null) && (id2 != null)) {
      id1 = id1.toLowerCase();
      id2 = id2.toLowerCase();
      return (id1.indexOf(id2) > -1) || (id2.indexOf(id1) > -1);
    } else {
      return false;
    }
  };

  StepTwoBaseView.prototype.findFlexibleContactChanel = function(categoryId, subcategoryId) {
    var categoryList, contactChannels, contactChannelsForSelectedCategory, matchedCategory;
    contactChannels = this.flexibleContactChannelModel.getContactChannels();
    if ((contactChannels != null) && (categoryId != null) && (subcategoryId != null)) {
      categoryList = _.keys(contactChannels);
      matchedCategory = _.find(categoryList, (function(_this) {
        return function(source) {
          return _this.areIdsSame(source, categoryId);
        };
      })(this));
      if (matchedCategory != null) {
        contactChannelsForSelectedCategory = $.extend(true, {}, contactChannels[matchedCategory].subCategories);
        return _.find(contactChannelsForSelectedCategory, (function(_this) {
          return function(channel) {
            return _this.areIdsSame(channel != null ? channel.id : void 0, subcategoryId);
          };
        })(this));
      }
    }
  };

  StepTwoBaseView.prototype.setFlexibleContactChannels = function() {
    var categoryId, contactChannelsForDropdown, ref, ref1, subcategoryId;
    if (this.isFlexibleContactChannelsEnabled()) {
      categoryId = (ref = Groupon.Support.ContentModel.getCategory()) != null ? ref.id : void 0;
      subcategoryId = (ref1 = Groupon.Support.ContentModel.getSubCategory()) != null ? ref1.id : void 0;
      contactChannelsForDropdown = this.findFlexibleContactChanel(categoryId, subcategoryId);
      if (contactChannelsForDropdown == null) {
        if (this.flexibleContactChannelModel.getContactChannels() != null) {
          TrackingHub.add("flexible-contactChannel-missing", SupportErrorHelper.constructFlexibleContactChannelMissingMessage());
        }
        return this.flexibleContactChannelModel.invalidateFlexibleContactChannels();
      }
      delete contactChannelsForDropdown.id;
      delete contactChannelsForDropdown.text;
      contactChannelsForDropdown = this.flexibleContactChannelModel.getAvailableContactChannelsForCallBack(contactChannelsForDropdown);
      contactChannelsForDropdown = this.flexibleContactChannelModel.removeNullChannels(contactChannelsForDropdown);
      contactChannelsForDropdown = this.flexibleContactChannelModel.filterContactChannelsByUserRegistrationDate(contactChannelsForDropdown);
      return this.flexibleContactChannelModel.setFlexibleContactChannels(contactChannelsForDropdown);
    }
  };

  return StepTwoBaseView;

})(Backbone.View);

module.exports = StepTwoBaseView;

//# sourceMappingURL=data:application/json;base64,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
